/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function ($) {
  $(".custom-fade-right").attr("data-aos", "fade-right");
  $(".custom-fade-right").attr("data-aos-duration", "2000");
  $(".custom-fade-right").attr("data-aos-offset", "150");
  $(".custom-fade-right").attr("data-aos-mirror", "true");
  $(".custom-fade-right").addClass("aos-init");
  $(".custom-fade-right").addClass("aos-animate");

  $(".custom-fade-left").attr("data-aos", "fade-left");
  $(".custom-fade-left").attr("data-aos-duration", "2000");
  $(".custom-fade-left").attr("data-aos-offset", "150");
  $(".custom-fade-left").attr("data-aos-mirror", "true");
  $(".custom-fade-left").addClass("aos-init");
  $(".custom-fade-left").addClass("aos-animate");

  $(".custom-fade-up").attr("data-aos", "fade-up");
  $(".custom-fade-up").attr("data-aos-duration", "2000");
  $(".custom-fade-up").attr("data-aos-offset", "150");
  $(".custom-fade-up").attr("data-aos-mirror", "true");
  $(".custom-fade-up").addClass("aos-init");
  $(".custom-fade-up").addClass("aos-animate");

  $(".custom-fade-down").attr("data-aos", "fade-down");
  $(".custom-fade-down").attr("data-aos-duration", "2000");
  $(".custom-fade-down").attr("data-aos-offset", "150");
  $(".custom-fade-down").attr("data-aos-mirror", "true");
  $(".custom-fade-down").addClass("aos-init");
  $(".custom-fade-down").addClass("aos-animate");

  AOS.init();

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery(".accordion p:empty, .orbit p:empty").remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(
    function () {
      if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
        jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
      } else {
        jQuery(this).wrap("<div class='responsive-embed'/>");
      }
    }
  );

  // $(".single-team-member").click(function ($) {
  //   jQuery(".highlight").hide();

  //   var id = this.id.match(/\d+/);

  //   jQuery(".highlight.highlight-" + id)
  //     .show()
  //     .get(0)
  //     .scrollIntoView({ behavior: "smooth" });
  // });

  // $(".single-board-member").click(function ($) {
  //   jQuery(".highlight").hide();

  //   var id = this.id.match(/\d+/);

  //   jQuery(".highlight.highlight-" + id)
  //     .show()
  //     .get(0)
  //     .scrollIntoView({ behavior: "smooth" });
  // });
});
